module.exports = __webpack_public_path__ + "static/media/microbrite.007bf88e.pdf";